import { Badge } from "@/components/ui/badge";
import { Button } from "@/components/ui/button";
import { FileEdit, Clock, Trash2, AlertTriangle } from "lucide-react";

export default function DraftSection({ drafts, onOpen, onDelete, draftType }) {
  if (!drafts || drafts.length === 0) return null;

  return (
    <div className="mb-4" data-testid="draft-section">
      <div className="flex items-center gap-2 mb-2">
        <FileEdit size={14} className="text-amber-600" />
        <span className="text-xs uppercase tracking-wider font-bold text-amber-600">
          Drafts ({drafts.length})
        </span>
      </div>
      <div className="space-y-2">
        {drafts.map((draft) => (
          <div
            key={draft.id}
            className="flex items-center justify-between p-3 border-2 border-dashed border-amber-300 bg-amber-50/50 rounded-lg hover:bg-amber-50 transition cursor-pointer"
            onClick={() => onOpen(draft)}
            data-testid={`draft-${draft.id}`}
          >
            <div className="flex items-center gap-3 min-w-0">
              <div className="min-w-0">
                <div className="text-sm font-medium truncate">
                  {draft.data?.visitor_name ||
                    draft.data?.employee_name ||
                    draft.data?.party_name ||
                    draft.data?.vehicle_no ||
                    draft.data?.key_name ||
                    draft.data?.material_description ||
                    "Untitled Draft"}
                </div>
                <div className="flex items-center gap-2 mt-0.5">
                  <span className="text-[10px] text-gray-400 flex items-center gap-1">
                    <Clock size={10} />
                    {new Date(draft.updated_at).toLocaleString("en-IN", {
                      hour: "2-digit", minute: "2-digit", day: "2-digit", month: "short",
                    })}
                  </span>
                  {draft.locked_by && (
                    <Badge variant="outline" className="text-[10px] h-4">
                      Editing: {draft.locked_by.split("@")[0]}
                    </Badge>
                  )}
                  {draft.is_stale && (
                    <Badge className="bg-red-100 text-red-700 text-[10px] h-4">
                      <AlertTriangle size={10} className="mr-0.5" /> Stale
                    </Badge>
                  )}
                </div>
              </div>
            </div>
            <div className="flex items-center gap-1 shrink-0">
              <Button
                variant="ghost"
                size="sm"
                className="h-7 w-7 p-0 text-red-400 hover:text-red-600 hover:bg-red-50"
                onClick={(e) => { e.stopPropagation(); onDelete(draft.id); }}
                data-testid={`delete-draft-${draft.id}`}
              >
                <Trash2 size={14} />
              </Button>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
